import { privateRequest } from "../axios";

const ENDPOINTS = {
  VENDOR_INTEGRATION: "/vendorIntegration",
  VENDOR_INTEGRATION_ID: (id) => `/vendorIntegration/${id}`,
  API_ENDPOINT: "/vendorIntegration/api-endpoint",
  API_ENDPOINT_ID: (vendorIntegrationId, id) =>
    `/vendorIntegration/${vendorIntegrationId}/api-endpoint/${id}`,
};

const getVendorIntegrations = async (params) => {
  const response = await privateRequest.get(ENDPOINTS.VENDOR_INTEGRATION, {
    params,
  });
  return response?.data;
};

const getVendorIntegrationById = async (id) => {
  const response = await privateRequest.get(
    ENDPOINTS.VENDOR_INTEGRATION_ID(id)
  );
  return response?.data;
};

const addVendorIntegration = async (data) => {
  const response = await privateRequest.post(
    ENDPOINTS.VENDOR_INTEGRATION,
    data
  );
  return response?.data;
};

const updateVendorIntegration = async (id, data) => {
  const response = await privateRequest.put(
    ENDPOINTS.VENDOR_INTEGRATION_ID(id),
    data
  );
  return response?.data;
};

const deleteVendorIntegration = async (id) => {
  const response = await privateRequest.delete(
    ENDPOINTS.VENDOR_INTEGRATION_ID(id)
  );
  return response?.data;
};

const addApiEndpoint = async (data) => {
  const response = await privateRequest.post(ENDPOINTS.API_ENDPOINT, data);
  return response?.data;
};

const getApiEndpoints = async (params) => {
  const response = await privateRequest.get(ENDPOINTS.API_ENDPOINT, {
    params,
  });
  return response?.data;
};

const deleteApiEndpoint = async (id, vendorIntegrationId) => {
  const response = await privateRequest.delete(
    ENDPOINTS.API_ENDPOINT_ID(vendorIntegrationId, id)
  );
  return response?.data;
};

const VendorIntegrationService = {
  getVendorIntegrations,
  getVendorIntegrationById,
  addVendorIntegration,
  updateVendorIntegration,
  deleteVendorIntegration,
  addApiEndpoint,
  getApiEndpoints,
  deleteApiEndpoint,
};

export default VendorIntegrationService;
